import { fetcher } from '@bino/utils/fetcher';
import { cart, common, createI18n, I18nProvider } from '@bino/utils/i18next';
import type { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';
import Cart from './components/cart/cart';
import GlobalCartError from './components/globalCartError/globalCartError';
import ApplyNow from './components/programmePage/applyNow';
import { ShoppingCartProvider, ShoppingCartProviderProps } from './context/CartContext';
import styles from './index.module.scss';

const i18n = createI18n(common, cart);

export const renderCart = (cartId: string, props: ShoppingCartProviderProps) => {
    const cartContainer = document.getElementById(cartId);

    if (!cartContainer) {
        return null;
    }

    const root = createRoot(cartContainer);
    root.render(
        <Wrapper props={props}>
            <Cart />
        </Wrapper>,
    );
};

export const renderApplyNow = (programmePageId: string, props: ShoppingCartProviderProps) => {
    const applyNowContainer = document.getElementById(programmePageId);

    if (!applyNowContainer) {
        return null;
    }

    const root = createRoot(applyNowContainer);

    root.render(
        <Wrapper props={props}>
            <div className={styles.container}>
                <ApplyNow />
            </div>
        </Wrapper>,
    );
};

function Wrapper({ children, props }: { children: ReactNode; props: ShoppingCartProviderProps }) {
    return (
        <I18nProvider i18n={i18n}>
            <SWRConfig
                value={{
                    revalidateOnMount: true,
                    revalidateOnFocus: true,
                    revalidateOnReconnect: true,
                    fetcher: fetcher.get,
                }}
            >
                <ShoppingCartProvider {...props}>
                    {children}
                    <GlobalCartError />
                </ShoppingCartProvider>
            </SWRConfig>
        </I18nProvider>
    );
}
